import React from "react";

const EditorFooter = ({
    editor,
}) => {
    return (
        <div className="w-100 editor-footer">
            
        </div>
    )
}

export default EditorFooter;
